import { xspocApiInstance } from "../api.ts";

export interface LoginURLResponse {
  LoginURL: string;
}

export interface AllyPreviewURLResponse {
  values: {
    AllyPreviewURL: string;
  };
  id: string;
  dateCreated: string;
}

const fetchLoginURLAsync = async (): Promise<LoginURLResponse | null> => {
  try {
    const response = await xspocApiInstance.get<{ values: LoginURLResponse }>(
      "EnvironmentType/GetLoginURL",
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );

    if (response && response.data && response.data.values) {
      return response.data.values;
    } else {
      console.log("No data found in response", response);
      return null;
    }
  } catch (error) {
    console.error("Error fetching Login URL", error);
    return null;
  }
};

const fetchAllyPreviewAsync = async (): Promise<AllyPreviewURLResponse | null> => {
  try {
    const response = await xspocApiInstance.get<AllyPreviewURLResponse>('/EnvironmentType/GetAllyPreviewURL', {
      headers: {
        'content-type': 'application/json',
      },
    });

    if (response && response.data) {
      return response.data;
    } else {
      console.log('No data found in response', response);
      return null;
    }
  } catch (error) {
    console.error('Error fetching ally preview URL', error);
    return null;
  }
};

export { fetchLoginURLAsync, fetchAllyPreviewAsync };
